import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Modal, Tabs } from 'antd'
import WrappedBrandProfile from '../BrandProfile'
import BrandNews from '../BrandNews'
import BrandCover from '../BrandCover'
import BrandProduct from '../BrandProduct'
import BrandMaterial from '../BrandMaterial'
import BrandSetting from '../BrandSetting'
import BrandHero from '../BrandHero'
import BrandActivity from '../BrandActivity'

const BrandForm = (props) => {
  const { visible, onOk, onCancel, formData } = props

  return (
    <Modal
      width={1000}
      destroyOnClose={true}
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a new brand`}
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Tabs type="card" defaultActiveKey="1">
        <Tabs.TabPane tab="Brand Profile" key="1">
          <WrappedBrandProfile
            onOk={onOk}
            onCancel={onCancel}
            formData={formData}
          />
        </Tabs.TabPane>
        {!_.isEmpty(formData) && (
          <Tabs.TabPane tab="Brand Cover" key="2">
            <BrandCover brandId={formData.id} />
          </Tabs.TabPane>
        )}
        {!_.isEmpty(formData) && (
          <Tabs.TabPane tab="Brand News" key="3">
            <BrandNews brandId={formData.id} />
          </Tabs.TabPane>
        )}
        {!_.isEmpty(formData) && (
          <Tabs.TabPane tab="Brand Activity" key="8">
            <BrandActivity brandId={formData.id} />
          </Tabs.TabPane>
        )}
        {!_.isEmpty(formData) && (
          <Tabs.TabPane tab="Brand Hero" key="4">
            <BrandHero brandId={formData.id} />
          </Tabs.TabPane>
        )}
        {!_.isEmpty(formData) && (
          <Tabs.TabPane tab="Brand Product" key="5">
            <BrandProduct brandId={formData.id} />
          </Tabs.TabPane>
        )}
        {!_.isEmpty(formData) && (
          <Tabs.TabPane tab="Brand Material" key="6">
            <BrandMaterial brand={formData} onCancel={onCancel} />
          </Tabs.TabPane>
        )}
        {!_.isEmpty(formData) && (
          <Tabs.TabPane tab="Brand Setting" key="7">
            <BrandSetting brand={formData} onCancel={onCancel} />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Modal>
  )
}

BrandForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default BrandForm



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandForm/index.js